<script setup>
import SvgIcon from "@/components/common/svgButton.vue";
import { computed, onMounted, ref} from "vue";
import {useUser} from "@/store/user";
import BlockView from "@/components/common/BlockView.vue";
import { t } from "@/controllerLK/GlobusLocalization";
import UserIcon
  from "@/pages/LKPage/LKWindow/LKProjectWindow/ProjectModal/AccessListModal/UserIcon.vue";
import UserCheckIcon from "@/assets/icons/UserCheckIcon.vue";

const props = defineProps({
  showUserList: {
    type: Boolean,
    default: false
  },
  isEdit: {
    type: Boolean,
    default: false
  },
  userList: {
    type: Array,
    required: true
  },
  project: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(["addUserList", "closeModal"]);

const userStore = useUser();

onMounted(async () => {
  if (props.isEdit) {
    for (let user of props.userList) {
      const foundedUser = userStore.organizationMembers.find((orgMember) => {
        return orgMember.userId === user;
      });

      if (foundedUser) {
        addedUserList.value.push(foundedUser);
      }
    }
  }
});

const organizationMembers = computed(() => {
  const uId = userStore.user.userId;
  const uIndex = userStore.organizationMembers.findIndex((user) => uId === user.userId);
  const user = userStore.organizationMembers[uIndex];
  return [user, ...userStore.organizationMembers.filter((u) => u.userId !== uId)];
});

// <!--TODO: 18.12.24, task 1050. Выбор прав и отображения владельца убрано,пока не появится реализация на беке-->
// const accessList = [
//   {
//     value: t("access_list_modal.option.read"),
//     icon: "eye-black"
//   },
//   {
//     value: t("access_list_modal.option.write"),
//     icon: "pen-black"
//   }
// ];

const addedUserList = ref([]);

const toggleUser = (value, user) => {
  if (value) {
    addedUserList.value.push(user);
  } else {
    const index = addedUserList.value.findIndex((item) => item === user);
    addedUserList.value.splice(index, 1);
  }
};

const checkUserToggle = (userId) => {
  return addedUserList.value.some((item) => item.userId === userId);
};

const saveUserList = () => {
  emit("addUserList", addedUserList.value);
  emit("closeModal");
};
</script>

<template>
  <div
    v-if="showUserList"
    class="user-list-modal"
  >
    <div class="header">
      <div class="header__title">
        {{ t('access_list_modal.title') }}
      </div>
      <div class="header__close">
        <SvgIcon
          height="20px"
          name="x"
          width="20px"
          @click="emit('closeModal')"
        />
      </div>
    </div>

    <div
      v-if="organizationMembers.length > 0"
      class="body scroll"
    >
      <div
        v-for="(user, index) in organizationMembers"
        :key="user"
        class="user"
        @click.self="toggleUser(!checkUserToggle(user.userId), user)"
      >
        <div
          :class="{'user-info_not_active': !checkUserToggle(user.userId)}"
          class="user-info"
          @click="toggleUser(!checkUserToggle(user.userId), user)"
        >
          <Checkbox
            v-if="index !== 0"
            :model-value="checkUserToggle(user.userId)"
            @update:model-value="value => { toggleUser(value, user) }"
          />
          <UserIcon
            :image="user.image"
            @click.self="toggleUser(!checkUserToggle(user.userId), user)"
          />
          <div
            :class="{'user-info__name_active': checkUserToggle(user.userId)} && index !== 0"
            class="user-info__name"
            @click.self="toggleUser(!checkUserToggle(user.userId), user)"
          >
            {{ user.lastName || user.firstName ?
              user.lastName + ' ' + user.firstName + ' ' + user?.middleName : user.userId }}
          </div>
          <div
            v-if="index === 0"
            class="user-info_right-block"
          >
            <UserCheckIcon />
            {{ t('access_list_modal.owner') }}
          </div>
        </div>
        <!--TODO: 18.12.24, task 1050. Выбор прав и отображения владельца убрано,пока не появится реализация на беке-->

        <!--        <div-->
        <!--          v-if="userStore.user.userId === user.userId"-->
        <!--          class="user__title"-->
        <!--        >-->
        <!--          <SvgIcon-->
        <!--            height="14px"-->
        <!--            name="user-check"-->
        <!--            width="14px"-->
        <!--          />-->
        <!--          {{ t('access_list_modal.option.owner') }}-->
        <!--        </div>-->
        <!--        <div-->
        <!--          v-else-->
        <!--          class="user__access"-->
        <!--        >-->
        <!--          <GlobusDropdown-->
        <!--            v-if="checkUserToggle(user.userId)"-->
        <!--            :option-list="accessList"-->
        <!--          />-->
        <!--        </div>-->
      </div>
    </div>

    <div
      v-else
      class="body-no-member"
    >
      {{ t('access_list_modal.no_members') }}
    </div>

    <ButtonAccentPrimary
      v-if="userStore.organizationMembers.length > 0"
      size="large"
      @click="saveUserList"
    >
      {{ t('access_list_modal.button.save') }}
    </ButtonAccentPrimary>
  </div>
  <BlockView
    v-if="showUserList"
  />
</template>

<style lang="scss" scoped>

.user-list-modal {
  position: fixed;
  z-index: 2001;
  top: 50%;
  left: 50%;
  display: flex;

  flex-direction: column;
  width: 440px;

  max-height: 450px;
  padding: 20px;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 0 0 100vmax rgba(0,0,0,.5);

  gap: 20px;

  .header {
    display: flex;
    justify-content: space-between;

    &__title {
      font-size: 14px;
      font-weight: 600;
    }

    &__close {
      cursor: pointer;
      user-select: none;
    }
  }

  .body-no-member {
    text-align: center;
    padding: 30px 20px 30px 20px;
    color: #373D3F;
    background: $background-color;
  }

  .body {
    overflow: auto;
    height: 100%;
    padding: 10px;
    border: 1px solid $globe-passive-color;
    border-radius: 8px;

    .user {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 40px;
      padding: 10px;
      border-radius: 8px;
      gap: 10px;

      &-info {
        position: relative;
        display: flex;
        gap: 4px;
        width: 100%;
        min-height: 16px;
        &_not_active {
          width: 100%;
        }
        &_owner {
          .checkbox-wrapper {
            visibility: hidden;
          }
        }
        &__image {
          width: 20px;
          min-width: 20px;
          height: 20px;
          min-height: 20px;
          border-radius: 50%;
        }
        &_right-block {
          position: absolute;
          top: 3px;
          right: 12px;
          display: flex;
          gap: 5px;
          color: $grey;
        }
        &__name {
          display: inline;
          overflow: hidden;
          align-content: center;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;

          &_active {
            color: #1890FF;
          }
        }

        & .checkbox {
          margin-top: 2px;
        }
      }

      &__title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: $globe-text-grey;
        gap: 5px;
      }

      &__access {
        color: $globe-text-grey;
      }
    }

    .user:hover {
      cursor: pointer;
      user-select: none;
      background: $hover-active-color;
    }

    .user_active {
      background: $hover-active-color;
    }
  }

  .footer {
    &__save {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 42px;
      padding: 6.4px 15px 6.4px 15px;
      cursor: pointer;
      user-select: none;
      color: $button-active-text-color;
      border-radius: 8px;
      background: $button-active-color;
    }
  }
}
</style>
